// extracted by mini-css-extract-plugin
export default {"content":"dF-z"};